"use client"

import { useEffect, useRef, useState } from 'react'
import { useI18n } from '@/context/i18n'

// Cargar CSS de Leaflet solo en el cliente
if (typeof window !== 'undefined') {
  try {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css'
    if (!document.querySelector('link[href*="leaflet.css"]')) {
      document.head.appendChild(link)
    }
  } catch (e) {
    // Silently ignore appendChild errors from CSS loading
  }
}

export interface Office {
  id: number
  name: string
  location: string
  country: string
  coordinates: [number, number]
  address: string
  phone: string
  email: string
  hours: string
  description: string
  contactName?: string
  // optional explicit maps link (if provided, used instead of computed one)
  mapsUrl?: string
  // optional bilingual display fields
  name_en?: string
  location_en?: string
  country_en?: string
  address_en?: string
  hours_en?: string
  description_en?: string
  // optional per-office review link (e.g., Google reviews URL)
  reviewUrl?: string
}

export const offices: Office[] = [
  {
    id: 1,
    name: "Toluca",
    location: "Toluca",
    country: "México",
    coordinates: [19.283445884585095, -99.66249906267058],
    address: "Calle Andrés Quintana Roo 529, Col. Francisco Murguía, CP 50130, Toluca, México",
    phone: "+52 712 231 5859",
    email: "contacto@grupo-let.com",
    hours: "Lun–Vie 10:00–19:00",
    description: "Atención integral para estudiantes y viajeros.",
    mapsUrl: 'https://maps.app.goo.gl/h819Rep2dY8r6fo8A',
    reviewUrl : 'https://maps.app.goo.gl/h819Rep2dY8r6fo8A',
    // EN display (optional improvements)
    country_en: "Mexico",
    address_en: "Calle Andrés Quintana Roo 529, Col. Francisco Murguía, CP 50130, Toluca, Mexico",
    hours_en: "Mon–Fri 10:00–19:00",
    description_en: "Comprehensive support for students and travelers."
  },
  {
    id: 3,
    name: "Metepec",
    location: "Metepec",
    country: "México",
    coordinates: [19.26620904686717, -99.57714422298216],
    address: "Av Tecnológico 1101, San Salvador Tizatlali, 52172 San Salvador Tizatlalli, Méx.",
    phone: "+52 712 231 5859",
    email: "contacto@grupo-let.com",
    hours: "Lun–Vie 9:30–17:30",
    description: "Atención en el Valle de Toluca y Metepec.",
    mapsUrl: 'https://maps.app.goo.gl/EYX2YjizXKPaNieJ7',
    reviewUrl : 'https://maps.app.goo.gl/EYX2YjizXKPaNieJ7',
    country_en: "Mexico",
    address_en: "Av Tecnológico 1101, San Salvador Tizatlali, 52172 San Salvador Tizatlalli, Mex.",
    hours_en: "Mon–Fri 9:30–17:30",
    description_en: "Service for the Toluca Valley and Metepec."
  },
  {
    id: 8,
    name: "Ciudad de México",
    location: "Ciudad de México",
    country: "México",
    coordinates: [19.4326, -99.1332],
    address: "Ciudad de México, México",
    phone: "+52 712 231 5859",
    email: "contacto@grupo-let.com",
    hours: "Lun–Vie 10:00–19:00",
    description: "Atención en Ciudad de México.",
    country_en: "Mexico",
    address_en: "Ciudad de México, Mexico",
    description_en: "Service in Mexico City."
  },
  {
    id: 7,
    name: "Guadalajara",
    location: "Guadalajara",
    country: "México",
    coordinates: [20.6597, -103.3496],
    address: "Guadalajara, Jalisco, México",
    phone: "+52 33 2822 0050",
    email: "maria@grupo-let.com",
    hours: "Lun–Vie 10:00–19:00",
    description: "Atención en Guadalajara y zona metropolitana.",
    country_en: "Mexico",
    address_en: "Guadalajara, Jalisco, Mexico",
    description_en: "Service in Guadalajara and metro area."
  },
  {
    id: 5,
    name: "Monterrey",
    location: "Monterrey",
    country: "México",
    coordinates: [25.6866, -100.3161],
    address: "Monterrey, Nuevo León, México",
    phone: "+52 712 231 5859",
    email: "contacto@grupo-let.com",
    hours: "Lun–Vie 10:00–19:00",
    description: "Atención para Monterrey y el norte del país.",
    country_en: "Mexico",
    address_en: "Monterrey, Nuevo León, Mexico",
    description_en: "Service for Monterrey and northern Mexico."
  },
  {
    id: 2,
    name: "Toronto",
    location: "Toronto",
    country: "Canadá",
    coordinates: [43.7055, -79.4250],
    address: "421 Eglinton Ave W Suite #8, Toronto, ON M5N 1A4, Canadá",
    phone: "+1 (416) 303-0259",
    email: "hello@linkeducation.ca",
    hours: "Mon–Fri 9:00–17:00",
    description: "Atención integral para estudiantes internacionales.",
    mapsUrl: 'https://maps.app.goo.gl/2oRtRvUw2V4p89fC6',
    reviewUrl : 'https://maps.app.goo.gl/2oRtRvUw2V4p89fC6',
    country_en: "Canada",
    address_en: "421 Eglinton Ave W Suite #8, Toronto, ON M5N 1A4, Canada",
    description_en: "Comprehensive support for international students."
  },
  {
    id: 6,
    name: "Vancouver",
    location: "Vancouver",
    country: "Canadá",
    coordinates: [49.2827, -123.1207],
    address: "Vancouver, BC, Canada",
    phone: "+1 (416) 303-0259",
    email: "hello@linkeducation.ca",
    hours: "Mon–Fri 9:00–17:00",
    description: "Atención local en Vancouver.",
    country_en: "Canada",
    description_en: "Local support in Vancouver."
  }
]

// Export a lightweight array with precomputed map links that pages can import
// Export a lightweight array that uses only explicit mapsUrl when provided.
// If a mapsUrl is not provided, the mapsUrl field will be an empty string so
// pages can decide how to handle missing links.
export const officeMaps = offices.map(office => ({
  id: office.id,
  location: office.location,
  location_en: office.location_en || office.location,
  mapsUrl: office.mapsUrl || '',
})).concat([
  {
    id: 9,
    location: 'Canadá',
    location_en: 'Canada',
    mapsUrl: 'https://maps.app.goo.gl/2oRtRvUw2V4p89fC6',
  }
])

interface InteractiveMapProps {
  selectedOffice: Office
  onSelect: (office: Office) => void
}

const MapLoader = ({ selectedOffice, onSelect }: InteractiveMapProps) => {
  const { lang, t } = useI18n()
  const [mounted, setMounted] = useState(false)
  const [mapReady, setMapReady] = useState(false)
  const mapContainerRef = useRef<HTMLDivElement>(null)
  const mapInstanceRef = useRef<any>(null)
  const markersRef = useRef<Map<number, any>>(new Map())

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    if (!mounted || !mapContainerRef.current) return

    let cleanup: (() => void) | undefined

    const loadMap = async () => {
      try {
        // Cargar Leaflet solo desde CDN para evitar problemas de build
        let L = (window as any).L
        
        if (!L) {
          console.log('Cargando Leaflet desde CDN...')
          // Cargar Leaflet desde CDN dinámicamente
          const script = document.createElement('script')
          script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js'
          script.onload = () => {
            // Esperar un poco para que Leaflet se inicialice completamente
            setTimeout(() => loadMap(), 100)
          }
          script.onerror = () => {
            console.error('Failed to load Leaflet from CDN')
          }
          document.head.appendChild(script)
          return
        }

        // Clear any existing map
        if (mapInstanceRef.current) {
          mapInstanceRef.current.remove()
          mapInstanceRef.current = null
        }

        // Fix leaflet icon issue
        // @ts-ignore
        delete L.Icon.Default.prototype._getIconUrl
        L.Icon.Default.mergeOptions({
          iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
          iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
          shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
        })

        // Create custom icon
        const createIcon = (isSelected: boolean) => L.divIcon({
          html: `
            <div style="
              background: ${isSelected ? '#fb0009' : '#ffffff'};
              border: 3px solid #fb0009;
              border-radius: 50%;
              width: 40px;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: 'DIN', sans-serif;
              font-weight: bold;
              font-size: 11px;
              color: ${isSelected ? '#ffffff' : '#fb0009'};
              box-shadow: 0 4px 12px rgba(251, 0, 9, 0.3);
              cursor: pointer;
              transition: all 0.3s ease;
            ">LET</div>
          `,
          className: 'custom-map-icon',
          iconSize: [56, 56],
          iconAnchor: [28, 28]
        })

        // Initialize map
        const map = L.map(mapContainerRef.current, {
          center: selectedOffice?.coordinates || [20.0, -100.0],
          zoom: 5,
          maxZoom: 16,
          zoomControl: true,
          scrollWheelZoom: true
        })

        // Add tile layer
        // Light basemap for pleasant UI (Esri Light Gray Base)
        L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
          attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
          maxZoom: 16
        }).addTo(map)

        // Add markers
        // Add markers and keep references
        const latLngs: any[] = []
        offices.forEach(office => {
          const marker = L.marker(office.coordinates, {
            icon: createIcon(office.id === selectedOffice?.id)
          })

          const tel = (office.phone || '').replace(/[^+\d]/g, '')
          const wa = (office.phone || '').replace(/[^\d]/g, '')
          const dispAddress = lang==='EN' ? (office.address_en || office.address) : office.address
          const dispLocation = lang==='EN' ? (office.location_en || office.location) : office.location
          const dispCountry = lang==='EN' ? (office.country_en || office.country) : office.country
          // Prefer an explicit mapsUrl on the office object (short link). If not
          // provided, fall back to a computed Google Maps search URL.
          const mapsUrl = (office.mapsUrl && office.mapsUrl.length > 0)
            ? office.mapsUrl
            : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(dispAddress || `${dispLocation}, ${dispCountry}`)}`
          const dispDescription = lang==='EN' ? (office.description_en || office.description) : office.description
          const popupContent = `
            <div style="padding: 12px; text-align: left; font-family: 'Montserrat', sans-serif; min-width: 220px;">
              <h3 style="margin: 0 0 6px 0; font-size: 15px; font-weight: 800; color: #111;">${lang==='EN' ? (office.name_en || office.name) : office.name}</h3>
              <div style="margin: 4px 0; font-size: 13px; color: #333;"><strong>${dispLocation}</strong>, ${dispCountry}</div>
              <div style="margin: 4px 0; font-size: 12px; color: #555;">${dispAddress || ''}</div>
              ${dispDescription ? `<div style=\"margin: 4px 0; font-size: 12px; color: #444; line-height: 1.35;\">${dispDescription}</div>` : ''}
              <div style="margin-top: 8px; display: flex; gap: 8px; flex-wrap: wrap;">
                <a href="${mapsUrl}" target="_blank" rel="noopener" style="background:#111;color:#fff;padding:6px 10px;border-radius:8px;font-size:12px;text-decoration:none;font-weight:800;">${lang==='EN' ? 'Directions' : 'Cómo llegar'}</a>
              </div>
            </div>
          `

          marker.bindPopup(popupContent)
          marker.on('click', () => onSelect(office))
          marker.addTo(map)
          markersRef.current.set(office.id, marker)
          latLngs.push(office.coordinates)
        })

        // Fit to all offices
        if (latLngs.length > 1) {
          const bounds = L.latLngBounds(latLngs as any)
          map.fitBounds(bounds, { padding: [40, 40] })
        }

        mapInstanceRef.current = map
        setMapReady(true)

        // Cleanup function
        cleanup = () => {
          if (mapInstanceRef.current) {
            mapInstanceRef.current.remove()
            mapInstanceRef.current = null
          }
        }

      } catch (error) {
        console.error('Error loading map:', error)
      }
    }

    // Delay map loading slightly to ensure DOM is ready
    const timer = setTimeout(loadMap, 100)

    return () => {
      clearTimeout(timer)
      if (cleanup) cleanup()
    }
  }, [mounted, onSelect]) // map init

  // Handle selected office changes
  useEffect(() => {
    if (!mapInstanceRef.current || !selectedOffice || !mapReady) return
    const L = (window as any).L
    // Update marker icons and open popup for selected
    markersRef.current.forEach((marker, id) => {
      const isSel = id === selectedOffice.id
      // recreate icon consistent with init
      const icon = L && L.divIcon ? L.divIcon({
        html: `
          <div style="
            background: ${isSel ? '#fb0009' : '#ffffff'};
            border: 3px solid #fb0009;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: 'DIN', sans-serif;
            font-weight: bold;
            font-size: 11px;
            color: ${isSel ? '#ffffff' : '#fb0009'};
            box-shadow: 0 4px 12px rgba(251, 0, 9, 0.3);
            cursor: pointer;
            transition: all 0.3s ease;
          ">LET</div>
        `,
        className: 'custom-map-icon',
        iconSize: [56, 56],
        iconAnchor: [28, 28]
      }) : undefined
      if (icon) marker.setIcon(icon)
      if (isSel) {
        marker.openPopup()
      }
    })

    mapInstanceRef.current.flyTo(selectedOffice.coordinates, 8, { duration: 0.8 })
  }, [selectedOffice, mapReady])

  if (!mounted) {
    return (
  <div className="h-full w-full min-h-[300px] bg-gray-100 animate-pulse flex items-center justify-center">
          <div className="text-center">
            <div className="w-8 h-8 border-4 border-[#fb0009] border-t-transparent rounded-full animate-spin mx-auto mb-2"></div>
          <span className="text-gray-600 text-sm">{t('loading_map') || (lang==='EN' ? 'Loading map...' : 'Cargando mapa...')}</span>
        </div>
      </div>
    )
  }

  return (
  <div className="relative w-full h-full min-h-[300px] bg-gray-50 overflow-hidden">
      <div 
        ref={mapContainerRef} 
        className="w-full h-full"
        style={{ minHeight: '300px' }}
      />
      
      {!mapReady && (
  <div className="absolute inset-0 bg-gray-100 animate-pulse flex items-center justify-center">
          <div className="text-center">
            <div className="w-8 h-8 border-4 border-[#fb0009] border-t-transparent rounded-full animate-spin mx-auto mb-2"></div>
            <span className="text-gray-600 text-sm">{t('loading_map') || (lang==='EN' ? 'Loading map...' : 'Cargando mapa...')}</span>
          </div>
        </div>
      )}
    </div>
  )
}

const InteractiveMap: React.FC<InteractiveMapProps> = ({ selectedOffice, onSelect }) => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  // Only render the map loader on the client side
  if (!isMounted) {
    return (
  <div className="h-full w-full min-h-[300px] bg-gray-100 animate-pulse flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-[#fb0009] border-t-transparent rounded-full animate-spin mx-auto mb-2"></div>
          <span className="text-gray-600 text-sm">Preparando mapa...</span>
        </div>
      </div>
    )
  }

  return <MapLoader selectedOffice={selectedOffice} onSelect={onSelect} />
}

export default InteractiveMap
